// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, default-param-last */
import { createSelector } from "reselect"
import type { OutputSelector } from "reselect"
import { Record, List, fromJS } from "immutable"

import * as actions from "./historyActions"
import type { Action } from "./historyActions"

const InitialState = Record({
  urls: List(),
})

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line no-undef
function historyReducer(state: InitialState | null | undefined = InitialState(), action: Action) {
  if (!(state instanceof InitialState)) return InitialState(fromJS(state))

  switch (action.type) {
    case actions.PUSH:
      // FIXME: a method has been detected that possibly mutates the object, consider a more
      // functional approach (Ramda might help)

      return state.update("urls", (urls) => urls.push(action.payload.url))

    default:
      return state
  }
}

export default historyReducer

type State = {
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line no-undef
  readonly history: InitialState
}

const getState = (state: State) => state.history

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLastUrl: OutputSelector<State, any, string> = createSelector(getState, (state) =>
  state.urls.last(),
)
